import moment from 'moment';

export const weekFirstDay = (week) => moment().week(week).startOf('week');

export const weekLastDay = (week) => moment().week(week).endOf('week');
